// extracted by mini-css-extract-plugin
export default {"legalFooter":"LegalFooter_legalFooter","twoFactorChange":"LegalFooter_twoFactorChange","legalText":"LegalFooter_legalText"};